import { render } from "./Polygons.vue?vue&type=template&id=18eb195c&scoped=true&lang=html"
import script from "./Polygons.vue?vue&type=script&lang=js"
export * from "./Polygons.vue?vue&type=script&lang=js"

import "./Polygons.vue?vue&type=style&index=0&id=18eb195c&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18eb195c"]])

export default __exports__